import './index.erb';
import './index.rb';
import s from './index.module.scss';
import CtaStatusBased from '../cta_status_based';

const context = document.querySelector(`.${s.root}`);
new CtaStatusBased(context);
